import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import './i18n';
import App from './App';
import { initAnalytics, setAnalyticsUserFromToken } from './utils/analytics';

// Boots Yandex.Metrica + GA4 only if the user has already accepted cookies.
// On a fresh visit nothing loads until CookieBanner.accept() runs setConsent(true).
initAnalytics();
// Restore user_id binding for returning sessions
setAnalyticsUserFromToken(localStorage.getItem('token'));

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);